module.exports = __webpack_public_path__ + "static/media/AXIS-2.0dc34ec6.png";